import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { SharedModule } from '@shared/shared.module';

@Component({
	selector: 'kwo-content-creator-card',
	templateUrl: './content-creator-card.component.html',
	styleUrls: ['./content-creator-card.component.scss'],
	imports: [CommonModule, RouterModule, SharedModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentCreatorCardComponent {
	@Input() creator: any;

	constructor(private router: Router) { }

	goToCreator(slug: string) {
		this.router.navigate(['vissers', slug]);
	}
} 